const hasNoValue = (field) => field.trim().length === 0;
const hasValidPasswordLength = (password) => password.trim().length >= 8;
const hasValidEmail = (email) =>
  email.trim().length > 3 && email.trim().includes("@");
const shouldHidePasswordError = (password) =>
  hasNoValue(password) || hasValidPasswordLength(password);
const shouldHideEmailError = (email) =>
  hasNoValue(email) || hasValidEmail(email);

export const errorPasswordLength = "passwordLength";
export const errorInvalidFormat = "invalidFormat";

export const bePendingErrors = (
  password,
  setPasswordError,
  email,
  setEmailError
) => {
  if (shouldHidePasswordError(password)) {
    setPasswordError();
  } else if (!hasValidPasswordLength(password)) {
    setPasswordError(errorPasswordLength);
  }
  if (shouldHideEmailError(email)) {
    setEmailError();
  } else if (!hasValidEmail(email)) {
    setEmailError(errorInvalidFormat);
  }
};

export const navigateToUserHome = (navigate) => {
  if (sessionStorage.getItem("user")) {
    navigate("/");
  }
};

export const canContinue = (email, password) => {
  return hasValidEmail(email) && hasValidPasswordLength(password);
};
